module.exports = __webpack_public_path__ + "img/dg9.0de9e85d.jpg";